// Client half of the single authorization primitive. Same shared can() the server
// route guards use — so a UI action and its route gate off identical logic.
import { can, type PermissionKey } from '@alignova/shared';
import { useAuth } from './AuthContext.tsx';

export function useCan(): (permission: PermissionKey) => boolean {
  const { user } = useAuth();
  return (permission: PermissionKey) => can(user, permission);
}
